import * as actionTypes from '../actions/actionTypes';

const initialState = {
	landingPageReady: false,
	showModal: false,
	showInModal:'',
	landingPagePosition: 0,
	showSideDrawer: false,
	landingPageElement:'',
	spinnerState:true,
	currentPath:'/',
};

const reducer = (state = initialState, action ) => {
	switch (action.type) {
		case actionTypes.LANDINGPAGE_READY:
			return {
				...state,
				landingPageReady: true
			};
		case actionTypes.CHANGE_MODAL:
			return {
				...state,
				showModal:action.modalState,
				showInModal:action.showInModal
			}
		case actionTypes.CHANGE_LANDINGPAGEPOSITION:
			return {
				...state,
				landingPagePosition:action.LPPosition,
			}
		case actionTypes.CHANGE_LANDINGPAGEELEMENT:
			return {
				...state,
				landingPageElement:action.LPElement
			}
		case actionTypes.CHANGE_SIDEDRAWER:
			return {
				...state,
				showSideDrawer:action.sideDrawerChange
			}
		case actionTypes.SPINNER_STATE:
			return {
				...state,
				spinnerState:action.spinner
			}
		case actionTypes.CHANGE_PATH:
			return {
				...state,
				currentPath:action.path
			}
		default:
			return state;
	}
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/reducer.js